export const TEN_SECONDS = 10_000

export const TEN_MINUTES = 600_000
